// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3225cedf","455":"6bf69af6","977":"3a4b85a0"}[chunkId] + ".chunk.js";
};